import React from "react";
import { useTranslation } from "react-i18next";
import { Row, Col, Button, Modal, Radio } from "antd";
import AdnPageTitle from "../common/adnPageTitle/AdnPageTitle";
import AdnTable from "../common/adnTable/AdnTable";
import AdnCard from "../common/adnCard/AdnCard";

const ReportListForm = ({
  loading,
  reportList,
  generateReport,
  handleRunReport,
  showParameterModal,
  handleBackParameterModal,
  handleSemesterChange,
}) => {
  const { t } = useTranslation();
  const title = t("report.form.title");

  const columns = [
    {
      title: t("report.form.columns.name"),
      dataIndex: "name",
      render: (text, record) => (
        <Button type="link" onClick={() => generateReport(record.key)}>
          {text}
        </Button>
      ),
    },
  ];

  return (
    <>
      <Row
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <AdnPageTitle title={title} />
      </Row>

      <AdnCard loading={loading}>
        <br />
        <Row>
          <Col span={24}>
            <AdnTable
              showPagination={false}
              columns={columns}
              data={reportList}
            />
          </Col>
        </Row>
      </AdnCard>

      <Modal
        title={t("report.form.modals.reportParameters")}
        open={showParameterModal}
        onOk={handleRunReport}
        okText={t("report.form.buttons.run")}
        cancelText={t("report.form.buttons.back")}
        onCancel={handleBackParameterModal}
      >
        <p>{t("report.form.labels.chooseSemester")}</p>
        <p>
          <Radio.Group onChange={handleSemesterChange} defaultValue={1}>
            <Radio value={1}>{t("report.form.semesters.first")}</Radio>
            <Radio value={2}>{t("report.form.semesters.second")}</Radio>
          </Radio.Group>
        </p>
      </Modal>
    </>
  );
};

export default ReportListForm;
